import { createContext, useContext } from 'react'
import { ReadyState } from 'react-use-websocket'

import type {
  SendWebSocketJsonMessage,
  SendWebSocketMessage,
  WebSocketMessageHandler,
  WebSocketMessageMatcher,
} from './core/types'

export type WebSocketContextValue = {
  connectionStatus: string
  isConnected: boolean
  isConnecting: boolean
  isLeaderTab: boolean
  readyState: ReadyState
  subscribeTicksMarketData: (symbols: readonly string[]) => () => void
  sendJsonMessage: SendWebSocketJsonMessage
  sendMessage: SendWebSocketMessage
  subscribeMessage: (
    matcher: WebSocketMessageMatcher,
    handler: WebSocketMessageHandler
  ) => () => void
}

export const WebSocketContext = createContext<WebSocketContextValue | undefined>(undefined)

export const useWebSocketContext = (): WebSocketContextValue => {
  const context = useContext(WebSocketContext)

  if (!context) {
    throw new Error('useWebSocketContext must be used within WebSocketProvider')
  }

  return context
}
